import { TrendAlertColumn } from "./types";

export const VOLUME_ALERTS_TABLE_COLUMNS: TrendAlertColumn[] = [
  {
    key: "condition",
    labelKey: "Condition",
    style: { width: "30%" },
  },
  {
    key: "targetVolume",
    labelKey: "Target Volume",
    style: { width: "25%" },
  },
  {
    key: "currentVolume",
    labelKey: "Current Volume",
    style: { width: "25%" },
  },
  {
    key: "edit",
    labelKey: "Edit",
    style: { width: "10%" },
  },
  {
    key: "delete",
    labelKey: "Delete",
    style: { width: "10%" },
  },
];

export const NEW_DATA_ALERTS_TABLE_COLUMNS: TrendAlertColumn[] = [
  { key: "condition", labelKey: "Condition", style: { width: "50%" } },
  { key: "minVolume", labelKey: "Min Volume", style: { width: "30%" } },
  { key: "edit", labelKey: "Edit", style: { width: "10%" } },
  { key: "delete", labelKey: "Delete", style: { width: "10%" } },
];
